import { Routes } from '@angular/router';
import { MenuComponent } from './pages/menu.component';
import { CheckoutComponent } from './pages/checkout.component';
import { PaymentSuccessComponent } from './pages/payment-success.component';
import { PaymentCancelComponent } from './pages/payment-cancel.component';

export const routes: Routes = [
  { path: '', component: MenuComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'success', component: PaymentSuccessComponent },
  { path: 'cancel', component: PaymentCancelComponent },
  { path: '**', redirectTo: '' }
];
